import { Component, OnInit, Output, Input,ElementRef } from '@angular/core';
import { Router, ActivatedRoute, NavigationExtras, RouterOutlet, Routes,RouterModule } from '@angular/router';
import { DwRoutingMessageService, AG_GRID_FW_COMPONENT, DwNewRouteKeyService } from '@webdpt/framework';
import { FxDapHttpClient } from 'app/implementation/shared/fx-http-client';
import { TranslateService } from '@ngx-translate/core';
import {HttpClient} from '@angular/common/http';



@Component({
  selector: 'app-fxed020-menu',
  templateUrl: './fxed020-menu.component.html',
  styleUrls: ['./fxed020-menu.component.less']
})
export class Fxed020MenuComponent implements OnInit {
  @Input() listData:any[] = []; //绑定所有商品品类
  public isChild = false;


  constructor(
    public http: FxDapHttpClient,
    public router: DwNewRouteKeyService,
    public route: ActivatedRoute,
    public dwMessage: DwRoutingMessageService,
    private translateService: TranslateService,
  ) { }

  ngOnInit() {
  }

}
